import { createElement } from 'react';
import { observer } from 'mobx-react';
import flowRight from 'lodash.flowright';
import withStyles, { WithStyles } from 'react-jss';
import { store, ComponentDesc } from '../store';
import { DropTarget, DropTargetConnector, DropTargetMonitor } from 'react-dnd';
import { ItemTypes } from '../Constants';
import ComponentWrapper from './ComponentWrapper';

const Card = ComponentWrapper(ItemTypes.COLUMN_WRAPPER);

const styles = {
    page: {
        width: '100%',
    },
};

interface IProps extends WithStyles<typeof styles> {
    connectDropTarget: any;
}

let findCard = (id) => {
    const cards = store.currentTemplate.rows;
    const card = cards.filter((c) => c.id === id)[0];

    return {
        card,
        index: cards.indexOf(card),
    };
};

let cloneCard = (descriptor) => {
    const { card, index } = findCard(descriptor.id);
    if (card) {
        let copy = JSON.parse(JSON.stringify(descriptor));
        copy.id = +new Date();
        copy.settings.columns.forEach((c) => {
            c.forEach((i, idx) => {
                i.id = copy.id + idx + 1;
            });
        });
        store.currentTemplate.rows.splice(index, 0, copy);
    }
};

let moveCard = (id, atIndex) => {
    const { card, index } = findCard(id);
    if (card) {
        console.log('rearrangin rows, ', id, atIndex);
        store.currentTemplate.rows.splice(index, 1); // removing what you are dragging.
        store.currentTemplate.rows.splice(atIndex, 0, card); // inserting it into hoverIndex.
    }
};

let removeCard = (id) => {
    const { card, index } = findCard(id);
    if (card) {
        store.currentTemplate.rows.splice(index, 1);
        store.ui.left_panel_view = store.ui.prev_view;
    }
};

const component: React.FunctionComponent<IProps> = ({ classes, connectDropTarget }) => (
    <div
        className={classes.page}
        onClick={(e) => e.stopPropagation()}
        style={{
            backgroundColor: store.currentTemplate.pageSettings.backgroundColor,
            color: store.currentTemplate.pageSettings.color,
            padding: store.currentTemplate.pageSettings.padding,
        }}>
        {store.currentTemplate.rows.length > 0 ? (
            <div>
                {store.currentTemplate.rows.map((c: ComponentDesc<any>, idx) => {
                    let token = store.getComponentTokenByName(c.type);
                    let C = token.screenComponent;
                    return <Card moveCard={moveCard} findCard={findCard} removeCard={removeCard} cloneCard={cloneCard} index={idx} id={c.id} type={token.type} component={C} key={c.type + '_' + idx} descriptor={c} />;
                })}
            </div>
        ) : (
            <div
                style={{
                    textAlign: 'center',
                    // border: '1px solid #639ECF',
                    outline: '#757575 solid 1px',
                    minHeight: '100px',
                    font: '400 13.3333px Verdana',
                    lineHeight: '30px',
                }}>
                <span>Drag and drop a column here</span>
            </div>
        )}
    </div>
);

export default flowRight([
    withStyles(styles),
    DropTarget(
        ItemTypes.COLUMN,
        {
            drop(props: ComponentDesc<any>, monitor: DropTargetMonitor, component: any) {
                console.log('Page: DROP: ', monitor.didDrop());
                if (!monitor.didDrop()) {
                    let item = monitor.getItem();
                    if (!item.id) {
                        item.id = +new Date();
                    }
                    if (!store.currentTemplate.rows.some((r) => r.id === item.id)) {
                        console.log('PAGE: pushing item to rows');
                        store.currentTemplate.rows.push(item);
                    }
                }
                store.tempCard = null;
                return { handled: true };
            },
            hover() {},
        },
        (connect: DropTargetConnector, monitor: DropTargetMonitor) => {
            return {
                connectDropTarget: connect.dropTarget(),
            };
        }
    ),
    observer,
])(component);
